import { render, staticRenderFns } from "./userArea.vue?vue&type=template&id=67a92b81"
import script from "./userArea.vue?vue&type=script&lang=js"
export * from "./userArea.vue?vue&type=script&lang=js"
import style0 from "./userArea.vue?vue&type=style&index=0&id=67a92b81&prod&lang=stylus"
import style1 from "./userArea.vue?vue&type=style&index=1&id=67a92b81&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./userArea.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports